import * as React from "react"
import type { SVGProps } from "react"
const SvgExpandAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="M480-80 240-320l57-57 183 183 183-183 57 57zM298-584l-58-56 240-240 240 240-58 56-182-182z" />
  </svg>
)
export default SvgExpandAll
